import Styled from 'styled-components';

import { media } from '../../../lib/StyledComponents';
import { LayoutSplash } from '../../../components/Layout/LayoutSplash';

export const VerLayoutSplash = Styled(LayoutSplash)`
  text-align: left;
  margin: 0 auto 3em;

  ${media.medium`
    max-width: 42.5em;
  `}

  * {
    text-align: left;
  }
`;
